import DevicePhoneList from "./DevicePhoneList.vue";

const devicePhoneListCtrl = new Vue({
    el: '#device-phone-list',
    components: {DevicePhoneList},
})

